import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-default-mobile-nav',
  templateUrl: './default-mobile-nav.component.html',
  styleUrls: ['./default-mobile-nav.component.scss']
})
export class DefaultMobileNavComponent implements OnInit {

  @Input() scope;
  constructor() { }

  ngOnInit(): void {
  }

}
